module.exports = __webpack_public_path__ + "img/smiley.88c47bfd.png";